
const headers = [
    {
      label: 'ชื่อ-นามสกุล',
      field: 'name'
    },
    {
      label: 'หมายเลขบัตรประชาชน',
      field: 'identityId'
    },
    {
      label: 'จัดการ',
      field: 'action'
    },
  ]

  export default headers